export default __webpack_public_path__ + "static/media/ngo-a035-2.39ba5e09.jpg";